import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '../../components/common/Button';
import styles from './styles.module.css';
import {
  faAngleLeft,
  faAngleRight,
  faPen,
} from '@fortawesome/free-solid-svg-icons';
import Input from '../../components/common/Input';
import { useState } from 'react';
import CheckBox from '../../components/common/CheckBox';
import Pagenation from '../../components/common/Pagenation';
import WorkTimesTable from './components/WorkTimesTable';
import EditingWorkTimesTable from './components/EditingWorkTimesTable';
import { getWorkTimeParam, putWorkTimesRequest } from '../../types/workTime';
import {
  useGetWorkTimeQuery,
  usePutWorkTimeMutation,
} from '../../api/workTimeApi';
import PolicyRequired from '../../components/common/PolicyRequired';
import FooterControl from '../../components/common/FooterControl';
import CsvDownload from '../../components/CsvDownload';
import CsvInput from '../../components/CsvInput';
import HeaderLayout from '../../components/HeaderLayout';
import FooterLayout, {
  FooterLayoutCenterize,
} from '../../components/FooterLayout';
import SelectPageSize from '../../components/common/SelectPageSize';
import { useSearchParams } from 'react-router-dom';
import { format } from 'date-fns';
import NoResultFound from '../../components/common/NoResultFound';
import classNames from 'classnames';
import { keyList, useKeyAction } from '../../services/useKeyAction';

function Calendar() {
  const [isEditing, setIsEditing] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const getUrlDate = searchParams.get('date');
  const date =
    getUrlDate && !Number.isNaN(new Date(getUrlDate).getTime())
      ? new Date(getUrlDate)
      : new Date();
  const setDateParamu = (dateParam: Date) => {
    setSearchParams((prev) => {
      prev.set('date', format(dateParam, 'yyyy-MM'));
      return prev;
    });
  };

  const initWorkTimes: Omit<getWorkTimeParam, 'page' | 'limit'> = {
    month: format(date, 'yyyy-MM'),
    inputState: 'all',
  };
  const [workTimesData, updateWorkTimesData] = useState<getWorkTimeParam>({
    ...initWorkTimes,
    page: 1,
    limit: 20,
  });

  const { data: workTimes } = useGetWorkTimeQuery(workTimesData);

  const goNext = () => {
    const nowDate = date;
    nowDate.setMonth(nowDate.getMonth() + 1);
    setDateParamu(nowDate);
    updateWorkTimesData((prev) => ({
      ...prev,
      month: format(date, 'yyyy-MM'),
    }));
  };
  const goBefore = () => {
    const nowDate = date;
    nowDate.setMonth(nowDate.getMonth() - 1);
    setDateParamu(nowDate);
    updateWorkTimesData((prev) => ({
      ...prev,
      month: format(date, 'yyyy-MM'),
    }));
  };

  const [driverName, setDriverName] = useState(initWorkTimes.driverName);
  const onChangeDriverName = (name: string) => {
    setDriverName(name);
  };

  const [isCheckShowUnset, setIsCheckShowUnset] = useState(false);

  const onClear = () => {
    setDriverName('');
    setIsCheckShowUnset(false);
    updateWorkTimesData((prev) => ({
      ...prev,
      page: 1,
      driverName: '',
      inputState: 'all',
    }));
  };

  const onSubmit = async () => {
    let inputState = '';
    if (isCheckShowUnset) inputState = 'notEnteredOnly';
    if (!isCheckShowUnset) inputState = 'all';
    updateWorkTimesData((prev) => ({
      ...prev,
      month: format(date, 'yyyy-MM'),
      inputState: inputState,
      driverName: driverName,
      page: 1,
    }));
  };

  const onChangePerPage = (perPage: string) => {
    updateWorkTimesData((prev) => ({
      ...prev,
      page: 1,
      limit: Number(perPage),
    }));
  };
  const onPage = (page: number) => {
    updateWorkTimesData((prev) => ({
      ...prev,
      page,
    }));
  };

  const chengeWorkTimes: putWorkTimesRequest = {
    workTime: [],
  };
  const [chengeWorkTimeBody, setChengeWorkTimeBody] =
    useState<putWorkTimesRequest>(chengeWorkTimes);
  const handleWorkTimesChange = (newValue: putWorkTimesRequest) => {
    setChengeWorkTimeBody(newValue);
  };
  const [putWorkTime] = usePutWorkTimeMutation();
  const chengeWorkTime = async () => {
    await putWorkTime({ workTime: chengeWorkTimeBody.workTime })
      .unwrap()
      .then(() => {
        setIsEditing(false);
        updateWorkTimesData({
          ...initWorkTimes,
          page: 1,
          limit: 20,
        });
      });
  };
  const [isToastPopUp, setIsToastPopUp] = useState(false);

  const onConditionEnter = useKeyAction(keyList.ENTER, onSubmit);

  return (
    <HeaderLayout
      title="勤務表"
      controls={
        <>
          <div className={styles.monthDate}>
            <div className={styles.month}>{format(date, 'yyyy/M')}</div>
            <button
              onClick={goBefore}
              onChange={() => goBefore()}
              className={styles.arrowButton}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>
            <button onClick={goNext} className={styles.arrowButton}>
              <FontAwesomeIcon icon={faAngleRight} />
            </button>
          </div>
          <div className={styles.buttons}>
            <PolicyRequired policy={10}>
              <div className={styles.button}>
                <CsvDownload
                  type={'workTimes'}
                  date={format(date, 'yyyy-MM')}
                  disabled={isEditing}
                />
              </div>
              <div className={styles.button}>
                <CsvInput type={'workTimes'} disabled={isEditing} />
              </div>
            </PolicyRequired>
            <PolicyRequired policy={9}>
              <div className={styles.button}>
                <Button
                  variants={['secondary', 'contain']}
                  onClick={() => {
                    setIsEditing(true);
                  }}
                  disabled={isEditing}
                >
                  <FontAwesomeIcon icon={faPen} className={styles.icon} />
                  編集
                </Button>
              </div>
            </PolicyRequired>
          </div>
        </>
      }
    >
      <FooterLayout
        main={
          <>
            <PolicyRequired policy={11}>
              <div className={styles.conditions} onKeyDown={onConditionEnter}>
                <div className={styles.conditionInputs}>
                  <div className={styles.driverName}>
                    <Input
                      value={driverName}
                      onChange={(e) => onChangeDriverName(e.target.value)}
                      variants={['fit']}
                      placeholder="ドライバー名"
                    ></Input>
                  </div>
                  <div className={styles.isShowUnset}>
                    <CheckBox
                      label="未設定の人を表示"
                      checked={isCheckShowUnset}
                      onChange={() => {
                        setIsCheckShowUnset((prevState) => !prevState);
                      }}
                    />
                  </div>
                  <div className={styles.conditionButtons}>
                    <div className={styles.clearButton}>
                      <Button
                        variants={['contain', 'cancel']}
                        onClick={onClear}
                      >
                        クリア
                      </Button>
                    </div>
                    <Button
                      variants={['contain', 'secondary', 'search']}
                      onClick={onSubmit}
                    >
                      検索
                    </Button>
                  </div>
                </div>
              </div>
            </PolicyRequired>
            {(workTimes ? workTimes.drivers : []).length > 0 ? (
              <>
                <div className={styles.pageContainer}>
                  <SelectPageSize
                    value={`${workTimesData.limit}`}
                    onChange={(e) => onChangePerPage(e.target.value)}
                  />
                  <div>
                    <Pagenation
                      page={workTimesData.page || 1}
                      onPage={onPage}
                      perPage={workTimesData.limit || 0}
                      total={workTimes ? workTimes.total : 0}
                    ></Pagenation>
                  </div>
                </div>
                <div
                  className={classNames(
                    styles.content,
                    isToastPopUp && styles.isToastPopUp
                  )}
                >
                  {isEditing ? (
                    <EditingWorkTimesTable
                      workTimes={workTimes ? workTimes.drivers : []}
                      month={format(date, 'yyyy-MM')}
                      workTimesChange={handleWorkTimesChange}
                    />
                  ) : (
                    <WorkTimesTable
                      workTimes={workTimes ? workTimes.drivers : []}
                      month={format(date, 'yyyy-MM')}
                    />
                  )}
                </div>
              </>
            ) : (
              <FooterLayoutCenterize>
                <div className={styles.noResultFound}>
                  <NoResultFound />
                </div>
              </FooterLayoutCenterize>
            )}
          </>
        }
        footer={
          <FooterControl setIsNeedBottomMargin={(v) => setIsToastPopUp(v)}>
            {isEditing ? (
              <>
                <div className={styles.cancel}>
                  <Button
                    variants={['fit', 'cancel']}
                    onClick={() => {
                      setIsEditing(false);
                      setChengeWorkTimeBody(chengeWorkTimes);
                    }}
                  >
                    キャンセル
                  </Button>
                </div>
                <div className={styles.decision}>
                  <Button
                    variants={['fit']}
                    type="submit"
                    onClick={() => {
                      chengeWorkTime();
                    }}
                  >
                    確定
                  </Button>
                </div>
              </>
            ) : null}
          </FooterControl>
        }
      />
    </HeaderLayout>
  );
}

export default Calendar;
